export const s3Content = `## 🔐 How to Find AWS S3 Credentials and Configuration

This guide explains how to find the required AWS credentials and S3 settings for programmatic access.

---

### 1. Where to Find Access Key ID

1. Sign in to the [AWS Management Console](https://aws.amazon.com/console/).
2. Go to the **IAM (Identity and Access Management)** service.
3. Click on **Users** in the left sidebar.
4. Select an existing user or create a new one using **Add user**.
5. During user creation, enable **Programmatic access**.
6. After completing the process, the **Access Key ID** will be shown.

---

### 2. Where to Find Secret Access Key

- The **Secret Access Key** is displayed only once during creation of the access key.
- If lost, generate a new one from:
  - **IAM > Users > [Your User] > Security credentials > Create access key**

---

### 3. Where to Find Bucket Name

1. Open the **S3** service in the AWS Console.
2. You will see a list of your S3 buckets.
3. The **Bucket Name** is shown in the **Name** column.

---

### 4. Where to Find Region

1. Go to the **S3** service in the AWS Console.
2. Find your bucket in the list.
3. The **Region** is shown in the **Region** column.
4. Alternatively, click the bucket and view the **Properties** tab to see the region.`;
